// extracted by mini-css-extract-plugin
export var deleteModal = "_f7-0";